import App from 'app/app.js';
import 'app/store/ShoppingCartStore.js';
import 'app/store/ProductCatalogStore.js';
import 'app/store/ContentStore.js';

function SuggestedProductService($filter, ShoppingCartStore, ProductCatalogStore, ContentStore) {
  this.suggestedProduct = {};

  this.getTranslatedContent = function (key) {
    var translatedContent = $filter('ltTranslateFilter')(key);

    if (translatedContent !== key) {
      return translatedContent;
    }

    return '';
  };

  this.getImageSource = function (skuCode, defaultLayoutThemeId) {
    var suggestedProductImage = this.getTranslatedContent('SKU_' + skuCode + '_' + defaultLayoutThemeId + '_IMAGE');

    return !!suggestedProductImage ? ContentStore.resolveContentImagePath(suggestedProductImage) : undefined;
  };

  this.getSuggestedAddOnProduct = function () {
    this.suggestedProduct = {};
    var suggestedProducts = ProductCatalogStore.filterSuggestiveSelling(
      ContentStore.getZoneDetails(ContentStore.zones.SUGGESTIVE_SELLING)
    );
    var suggestedProductsNotInCart = ShoppingCartStore.getSuggestedProductsNotInCart(suggestedProducts) || [];
    if (suggestedProductsNotInCart.length > 0) {
      var productCatalog = ProductCatalogStore.getProductCatalog();
      for (var i = 0; i < suggestedProductsNotInCart.length; i++) {
        var matchingAddOn = R.find(R.propEq('skuCode', suggestedProductsNotInCart[i]))(productCatalog.addOns);
        if (matchingAddOn) {
          var suggestedProductImage = this.getImageSource(
            suggestedProductsNotInCart[i],
            matchingAddOn.defaultLayoutThemeId
          );
          if (suggestedProductImage) {
            this.suggestedProduct.addOn = matchingAddOn;
            this.suggestedProduct.image = suggestedProductImage;
            break;
          }
        }
      }
    }
    return this.suggestedProduct;
  };
}

App.service('SuggestedProductService', [
  '$filter',
  'ShoppingCartStore',
  'ProductCatalogStore',
  'ContentStore',
  SuggestedProductService
]);
